import React, { useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import { apiHolder, inWindow, locationHelper, apis, environment } from 'api';
import debounce from 'lodash/debounce';
import Launch from '@web-account/Launch/launch';
import MailBindModal from '@web-account/Login/modal/bindAccount';
import Loadable from '@loadable/component';
const LoginModal = Loadable(() => import('@web-account/Login/modal/loginModal'));
import { getBodyFixHeight, ELECTRON_TITLE_FIX_HEIGHT, SIDE_BAR_WIDTH, isTabWindow, isMainWindow as needRootDragHeight } from '@web-common/utils/constant';
import { ClassifyContentModal } from '@web-common/components/CustomMailClassify/classify-content-modal';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { getMenuSettingsAsync, getPrivilegeAsync } from '@web-common/state/reducer/privilegeReducer';
import { getAreaSelectAsync, getBaseSelectAsync } from '@web-common/state/reducer/customerReducer';
import PaidGuidemodule from '@web-mail/components/PaidGuideModal/index';
import ReducerCompontent from './reducerComponent';
import styles from './index.module.scss';
import TitleBar from '@/components/Electron/TitleBar';
import WebToolbar from '@/layouts/Main/webToolbar';
import { getIn18Text } from 'api';
import LockApp from './lock-app';
import DebugPanel from '@web-common/components/UI/DebugTools';
const systemApi = apiHolder.api.getSystemApi();
const eventApi = apiHolder.api.getEventApi();
const dataTrackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const inElectron = systemApi.isElectron;
const isMac = inElectron() ? window.electronLib.env.isMac : apiHolder.env.isMac;
const DEBUG_OPEN_EVENT = '9357135c50e5cb2df105de5d0dde88b8';
const DEBUG_CLOSE_EVENT = '21b0fc3242c0ca0c320708a077e32bbb';
const isNonProdEnv = ['local', 'dev', 'test', 'test1', 'test2', 'prev'].includes(environment);
const ContainerWrap = ({ children, isLogin, showMin, showMax, showClose, show, className = '', activeKey, pages = '' }) => {
    const dispatch = useAppDispatch();
    const { mailBindModalInfo, loginModalData } = useAppSelector(state => state.loginReducer);
    const [visibleLaunch, setVisibleLaunch] = useState(systemApi.isMainPage());
    const fixHeight = getBodyFixHeight(false, true);
    const debounceToggleMax = useCallback(debounce(() => {
        console.log('debounceToggleMax');
        window.electronLib.windowManage.toggleMaximize();
    }, 500, { leading: true, trailing: false }), []);
    const onLaunch = () => {
        setVisibleLaunch(false);
        dataTrackerApi.track('home_page_loaded');
    };
    const eleDBCLick = (ele) => {
        const eleList = ele.path;
        const canMax = eleList.slice(0, 10).some(item => {
            try {
                const eleCSS = window.getComputedStyle(item);
                const str = eleCSS.webkitAppRegion;
                return str.includes('no-drag');
            }
            catch (error) {
                return false;
            }
        });
        if (!canMax) {
            console.log('toggleMaximize');
            debounceToggleMax();
        }
    };
    useEffect(() => {
        if (process.env.BUILD_ISEDM && (systemApi.isMainPage() || locationHelper.testPathMatch('/writeMail') || locationHelper.testPathMatch('/readMail'))) {
            dispatch(getMenuSettingsAsync());
            dispatch(getPrivilegeAsync());
            dispatch(getBaseSelectAsync());
            dispatch(getAreaSelectAsync());
        }
    }, []);
    if (process.env.BUILD_ISELECTRON) {
        useEffect(() => {
            window.addEventListener('dblclick', e => {
                if (systemApi.isMainWindow()) {
                    const height = 60;
                    if (e.clientY <= height) {
                        eleDBCLick(e);
                    }
                    else if (e.clientY > height && e.clientX < SIDE_BAR_WIDTH) {
                        eleDBCLick(e);
                    }
                }
                else if (e.clientY <= ELECTRON_TITLE_FIX_HEIGHT) {
                    eleDBCLick(e);
                }
            }, false);
        }, []);
    }
    const [isLockApp, setIsLockApp] = useState(systemApi.getIsLockApp());
    const [debugPanelVisible, setDebugPanelVisible] = useState(isNonProdEnv);
    if (isLockApp) {
        systemApi.switchLoading(false);
    }
    useEffect(() => {
        const eventName = 'onAppLockChanged';
        const eventId = eventApi.registerSysEventObserver(eventName, {
            func: data => {
                if (data && data.eventData) {
                    const isLockApp = data.eventData.isLockApp;
                    setIsLockApp(isLockApp);
                }
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver(eventName, eventId);
        };
    }, []);
    useEffect(() => {
        if (isNonProdEnv)
            return;
        const onOpen = () => setDebugPanelVisible(true);
        const onClose = () => setDebugPanelVisible(false);
        window.addEventListener(DEBUG_OPEN_EVENT, onOpen);
        window.addEventListener(DEBUG_CLOSE_EVENT, onClose);
        return () => {
            window.removeEventListener(DEBUG_OPEN_EVENT, onOpen);
            window.removeEventListener(DEBUG_CLOSE_EVENT, onClose);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(styles.siriusContainer, 'wrap-component-class-flag', className) },
            process.env.BUILD_ISELECTRON && isLockApp && React.createElement(LockApp, null),
            React.createElement("div", { className: `${styles.rootWrap} ${isLogin && styles.whiteBg}`, style: { top: fixHeight } }, children),
            process.env.BUILD_ISELECTRON && inWindow() && React.createElement("div", { className: `${needRootDragHeight() ? styles.rootDragEle : ''} ${isTabWindow() ? styles.resourceTab : ''}` }),
            process.env.BUILD_ISELECTRON && inWindow() ? (React.createElement(TitleBar, { activeKey: activeKey, pages: pages, isLockApp: isLockApp, isLogin: isLogin, showMin: showMin, showClose: showClose, showMax: showMax, show: show })) : null,
            !process.env.BUILD_ISELECTRON && systemApi.isMainPage() && !systemApi.inEdm() && React.createElement(WebToolbar, null),
            React.createElement(ReducerCompontent, null),
            visibleLaunch && !isLockApp && React.createElement(Launch, { onLaunch: onLaunch }),
            React.createElement(MailBindModal, { title: getIn18Text('YANZHENGNINDEWANG'), visible: mailBindModalInfo.visible, defaultAccount: mailBindModalInfo.account, from: "account" }),
            loginModalData.visible && React.createElement(LoginModal, null),
            React.createElement(ClassifyContentModal, null),
            React.createElement(PaidGuidemodule, null),
            debugPanelVisible && React.createElement(DebugPanel, null))));
};
export default ContainerWrap;
